/* global axios */
import ApiClient from './ApiClient';

const buildCsatParams = ({
  page,
  per_page,
  from,
  to,
  user_ids,
  inbox_id,
  team_id,
  rating,
  label_title,
  exclude_label_title,
  resolution_method,
  has_comment,
  comparisonPeriods,
} = {}) => {
  const params = {
    page,
    per_page,
    since: from,
    until: to,
    sort: '-created_at',
    'user_ids[]': user_ids,
    'inbox_id[]': inbox_id,
    'team_id[]': team_id,
    'rating[]': rating,
    'label_title[]': label_title,
    'exclude_label_title[]': exclude_label_title,
    resolution_method,
    has_comment,
  };

  if (comparisonPeriods?.length) {
    params.comparison_periods = JSON.stringify(
      comparisonPeriods.map(period => ({
        since: period.from ?? period.since,
        until: period.to ?? period.until,
      }))
    );
  }

  return params;
};

class CSATReportsAPI extends ApiClient {
  constructor() {
    super('csat_survey_responses', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params: buildCsatParams(params) });
  }

  download(params = {}) {
    return axios.get(`${this.url}/download`, {
      params: buildCsatParams(params),
    });
  }

  getMetrics(params = {}) {
    return axios.get(`${this.url}/metrics`, {
      params: buildCsatParams(params),
    });
  }

  getDynamics(params = {}) {
    return axios.get(`${this.url}/dynamics`, {
      params: buildCsatParams(params),
    });
  }

  getBreakdown(params = {}) {
    return axios.get(`${this.url}/breakdown`, {
      params: {
        ...buildCsatParams(params),
        group_by: params.group_by || 'agent',
      },
    });
  }
}

export default new CSATReportsAPI();
